export const SCHOLAR_1_CONSTANTS = {
    DEFAULT_ROW: {
      id: "1",
      meta_icon: "",
      meta_alt_icon: "Scholar icon",
      meta_description: "Sample scholar benefit description",
      meta_priority: 1,
      meta_status: true,
      meta_description_text_color: "#000000",
    },
  
    SCHOLAR_FIELDS_CONFIG: [
      {
        fieldName: "background_color",
        label: "Background Color",
        value: "#FFFFFF",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter background color (e.g., #FFFFFF)",
        required: false,
        defaultValue: "#FFFFFF",
      },
      {
        fieldName: "title",
        label: "Scholar Title",
        value: "Why Choose Our Program",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Scholar Title",
        required: false,
        defaultValue: "Why Choose Our Program",
      },
      {
        fieldName: "title_text_color",
        label: "Title Text Color",
        value: "#000000",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter title text color (e.g., #000000)",
        required: false,
        defaultValue: "#000000",
      },
      {
        fieldName: "desktop_bg_image",
        label: "Desktop Background Image",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Upload Desktop Background Image",
        required: false,
        defaultValue: "",
      },
      {
        fieldName: "mobile_bg_image",
        label: "Mobile Background Image",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Upload Mobile Background Image",
        required: false,
        defaultValue: "",
      },
      {
        fieldName: "alt_image",
        label: "Alt Image Text",
        value: "Scholar section background",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Alt Image Text",
        required: false,
        defaultValue: "Scholar section background",
      },
      {
        fieldName: "status",
        label: "Scholar Status",
        value: false,
        valueType: "boolean",
        filedType: "TOGGLE",
        placeholder: "Enable/Disable Scholar",
        defaultValue: false,
      }
    ],
  
    METADATA_FIELDS: [
      {
        header: "Icon",
        fieldName: "meta_icon",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Upload Icon",
      },
      {
        header: "Alt Icon",
        fieldName: "meta_alt_icon",
        value: "",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Alt Icon Text",
      },
      {
        header: "Description",
        fieldName: "meta_description",
        value: "",
        valueType: "string",
        filedType: "TEXT_AREA",
        placeholder: "Enter Description",
      },
      {
        header: "Description Text Color",
        fieldName: "meta_description_text_color",
        value: "#000000",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter description text color (e.g., #000000)",
        defaultValue: "#000000",
      },
      {
        header: "Priority",
        fieldName: "meta_priority",
        value: "",
        valueType: "number",
        filedType: "INPUT",
        placeholder: "Enter Priority",
        required: true,
      },
      {
        header: "Status",
        fieldName: "meta_status",
        value: "",
        valueType: "boolean",
        filedType: "TOGGLE",
        placeholder: "Enter Status",
      },
    ]
  };